import { Banner } from '../types';

export const banners: Banner[] = [
  {
    id: '1',
    title: 'New Collection 2025',
    subtitle: 'Discover the latest trends in fashion',
    image: '/images/banners/hero-banner-1.jpg',
    link: '/collections/new',
    buttonText: 'Shop Now',
    isActive: true,
  },
  {
    id: '2',
    title: 'Summer Sale',
    subtitle: 'Up to 50% off on selected items',
    image: '/images/banners/hero-banner-2.jpg',
    link: '/collections/sale',
    buttonText: 'Explore Sale',
    isActive: true,
  },
  {
    id: '3',
    title: 'Premium Quality',
    subtitle: 'Handpicked products for you',
    image: '/images/banners/hero-banner-3.jpg',
    link: '/collections/premium',
    buttonText: 'View Collection',
    isActive: true,
  },
];

export const getActiveBanners = (): Banner[] => {
  return banners.filter(banner => banner.isActive);
};
